import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentBox } from "@msuite/ui/content-box";
import { useTranslation } from "@msuite/ui/localization";
import { toast } from "@msuite/ui/toast";
import { responseHandler } from "@msuite/ui/utils";
import type { CalculationType } from "@msuite/utils/types";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { client } from "@/hono";

export function CalculationInitialization() {
	/** Hooks */
	const { t } = useTranslation();
	const navigate = useNavigate();

	/** Functions */
	async function initializeCalculation() {
		try {
			const type = new URLSearchParams(window.location.search).get("type") as CalculationType;
			const identifier = new URLSearchParams(window.location.search).get("identifier");
			if (!type) throw new Error("Type is required");
			if (type === "parsc" && !identifier) throw new Error("Identifier is required");
			const response = await client.calculations.init.$post({
				json: type === "parsc" ? { type, identifier: identifier as string } : { type: "offer" },
			});
			const data = await responseHandler(response);
			if (!data.calculationId) throw new Error("Failed to initialize calculation");
			let url = `/calculations/${data.calculationId}/editor?limiter=external`;
			if (new URLSearchParams(window.location.search).get("returnTo")) {
				url += `&returnTo=${new URLSearchParams(window.location.search).get("returnTo")}`;
			}
			navigate(url);
		} catch (error) {
			toast.error((error as Error).message);
		}
	}

	/** Effects */
	useEffect(() => {
		initializeCalculation();
	}, []);

	/** Render */
	return (
		<ContentBox>
			<div className="w-full h-full gap">
				<BlankSlate
					isLoading
					withBorder={false}
					withAccessory={false}
					withBackground={false}
					label={t("calculations.initializing_calculation")}
				/>
			</div>
		</ContentBox>
	);
}
